import { render, staticRenderFns } from "./products.vue?vue&type=template&id=5cc0b640&scoped=true&"
import script from "./products.vue?vue&type=script&lang=ts&"
export * from "./products.vue?vue&type=script&lang=ts&"
import style0 from "./products.vue?vue&type=style&index=0&id=5cc0b640&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc0b640",
  null
  
)

export default component.exports